import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Member',
  meta: {
    icon: 'fa-user',
    expanded: false,
    roles: Global.ALL_ROLE
  },
  children: [
    {
      name: 'VTI Member',
      meta: {
        roles: [Global.ROLE.ADMIN, Global.ROLE.TEAMLEAD, Global.ROLE.GROUPMANAGER, Global.ROLE.ACCOUNTANT]
      },
      path: '/user/all',
      component: lazyLoading('user/UserList')
    },
    {
      name: 'Add New Member',
      meta: {
        roles: [Global.ROLE.ADMIN]
      },
      path: '/user/createUser',
      component: lazyLoading('user/CreateNewUser')
    },
    {
      name: 'User Profile',
      meta: {
        label: 'My Profile',
        roles: Global.ALL_ROLE,
        link: '/user/userDetail/id/'
      },
      path: '/user/userDetail/id/:id',
      component: lazyLoading('user/UserDetail')
    },
    {
      name: 'All User Request',
      meta: {
        label: 'All Request',
        roles: [Global.ROLE.ADMIN],
        link: '/user/allRequest/'
      },
      path: '/user/allRequest/:id',
      component: lazyLoading('user/AllRequest')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/user.js